import LZString from 'lz-string'

const PREFIX = '__lz__'

function sizeInKB(str) {
  return new Blob([str]).size / 1024
}

export const saveCompressedToLocalStorage = (key, data) => {
  try {
    const json = JSON.stringify(data)
    const compressed = LZString.compressToUTF16(json)

    localStorage.setItem(key, PREFIX + compressed)
    return true
  } catch (e) {
    console.error('saveCompressedToLocalStorage failed:', e)
    return false
  }
}

export const getCompressedFromLocalStorage = (key) => {
  const value = localStorage.getItem(key)
  if (!value) return null

  try {
    if (!value.startsWith(PREFIX)) {
      // Check if it's a valid JSON string before parsing
      try {
        return JSON.parse(value)
      } catch (e) {
        // If not JSON, return as is (useful for raw strings like usernames)
        return value
      }
    }

    const compressed = value.slice(PREFIX.length)
    const json = LZString.decompressFromUTF16(compressed)

    if (!json) {
      console.warn(`Decompression failed for key: ${key}. Returning null.`)
      return null
    }

    try {
      return JSON.parse(json)
    } catch (e) {
      console.error('Parsing decompressed JSON failed for key:', key, e)
      return null
    }
  } catch (e) {
    console.error('getCompressedFromLocalStorage failed for key:', key, e)
    return null
  }
}
